/**
 * Animation constants
 * 애니메이션 관련 상수들을 정의합니다.
 */
import { keyframes } from 'styled-components';

// Modal animation CSS (animation + keyframes 통합)
export const MODAL_FADE_IN_CSS = `
  animation: fadeIn 0.3s ease-out;

  @keyframes fadeIn {
    from {
      opacity: 0;
      transform: scale(1);
    }
    to {
      opacity: 1;
      transform: scale(1);
    }
  }
`;

export const MODAL_BACKGROUND_FADE_IN_CSS = `
  animation: fadeInBackground 0.3s ease-out;

  @keyframes fadeInBackground {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }
`;

export const TOAST_SLIDE_UP_CSS = `
  animation: slideUp 0.3s ease-out;

  @keyframes slideUp {
    from {
      transform: translateY(100%);
      opacity: 0;
    }
    to {
      transform: translateY(0);
      opacity: 1;
    }
  }
`;

export const TOAST_BACKGROUND_FADE_IN_CSS = `
  animation: fadeInBackground 0.3s ease-out;

  @keyframes fadeInBackground {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }
`;

export const BOTTOM_FADE_IN_CSS = `
  animation: fadeInFromBottom 0.3s ease-out;

  @keyframes fadeInFromBottom {
    from {
      opacity: 0;
      transform: translateY(0px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }
`;

export const CONTAINER_FADE_IN_CSS = `
  animation: fadeInContainer 0.3s ease-out;

  @keyframes fadeInContainer {
    from {
      opacity: 0;
      transform: translateY(0px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }
`;

// 좌측 하단(이야기학습 버튼) 기준점에서 펼쳐지듯 등장
export const NUDGE_IN_CSS = `
  transform-origin: left bottom;
  animation: nudgePopIn 0.4s cubic-bezier(0.34, 1.56, 0.64, 1);

  @keyframes nudgePopIn {
    from {
      opacity: 0;
      transform: scale(0.3);
    }
    to {
      opacity: 1;
      transform: scale(1);
    }
  }
`;

// 좌측 하단으로 다시 접히듯 퇴장
export const NUDGE_OUT_CSS = `
  transform-origin: left bottom;
  animation: nudgePopOut 0.25s ease-in forwards;

  @keyframes nudgePopOut {
    from {
      opacity: 1;
      transform: scale(1);
    }
    to {
      opacity: 0;
      transform: scale(0.3);
    }
  }
`;
